import * as AgreementCheckboxWrapper from './components/AgreementCheckboxWrapper.css';
import * as AgreementCheckbox from './components/AgreementCheckbox/AgreementCheckbox.css';
export default {
    AgreementCheckboxWrapper,
    AgreementCheckbox
};
